<template>
  <el-image
      style="width: 100px; height: 100px"
      src="/logo.png"
      fit="fill"
  ></el-image>
  <el-menu :router="true" :default-active="activeMenuIndex">
    <el-menu-item :index="`/admin/dashboard`" @click="menuClick">
      <el-icon><data-board /></el-icon><span>总览</span>
    </el-menu-item>
    <el-menu-item v-if="isRoot || rList.includes('/admin/question')" :index="`/admin/question`" @click="menuClick">
      <el-icon><mostly-cloudy /></el-icon><span>题库</span>
    </el-menu-item>
    <el-menu-item v-if="isRoot || rList.includes('/admin/test_papers')" :index="`/admin/test_papers`" @click="menuClick">
      <el-icon><document /></el-icon><span>试卷</span>
    </el-menu-item>
    <el-menu-item v-if="isRoot || rList.includes('/admin/grades')" :index="`/admin/grades`" @click="menuClick">
      <el-icon><notebook /></el-icon><span>年级</span>
    </el-menu-item>
    <el-menu-item v-if="isRoot || rList.includes('/admin/knowledge_points')" :index="`/admin/knowledge_points`" @click="menuClick">
      <el-icon><reading /></el-icon><span>知识点</span>
    </el-menu-item>
    <el-sub-menu v-if="isRoot || rList.includes('/admin/knowledge')" :index="`/admin/knowledge`">
      <template #title>
        <el-icon><collection-tag /></el-icon><span>学科</span>
      </template>
      <el-menu-item v-if="isRoot || rList.includes('/admin/subjects')" :index="`/admin/subjects`" @click="menuClick">
        <el-icon><tickets /></el-icon><span>学科</span>
      </el-menu-item>
      <el-menu-item v-if="isRoot || rList.includes('/admin/textbook')" :index="`/admin/textbook`" @click="menuClick">
        <el-icon><notebook /></el-icon><span>教材</span>
      </el-menu-item>
      <el-menu-item v-if="isRoot || rList.includes('/admin/chapter')" :index="`/admin/chapter`" @click="menuClick">
        <el-icon><grape /></el-icon><span>章节</span>
      </el-menu-item>
    </el-sub-menu>
    <el-menu-item v-if="isRoot || rList.includes('/admin/article')" :index="`/admin/article`" @click="menuClick">
      <el-icon><document-copy /></el-icon><span>免费资源</span>
    </el-menu-item>
    <el-menu-item v-if="isRoot || rList.includes('/admin/members')" :index="`/admin/members`" @click="menuClick">
      <el-icon><user /></el-icon><span>用户</span>
    </el-menu-item>
    <el-menu-item v-if="isRoot || rList.includes('/admin/orders')" :index="`/admin/orders`" @click="menuClick">
      <el-icon><shopping-bag /></el-icon><span>订单</span>
    </el-menu-item>
    <el-sub-menu v-if="isRoot" :index="`/admin/settings`">
      <template #title>
        <el-icon><setting /></el-icon><span>设置</span>
      </template>
      <el-menu-item v-if="isRoot" :index="`/admin/users/index`" @click="menuClick">
        <el-icon><key /></el-icon><span>账号管理</span>
      </el-menu-item>
      <el-menu-item v-if="isRoot" :index="`/admin/users/group`" @click="menuClick">
        <el-icon><postcard /></el-icon><span>权限分组</span>
      </el-menu-item>
    </el-sub-menu>
  </el-menu>
</template>
<script lang="ts" setup>
import store from "../../store";
import {useRouter} from "vue-router";
import {useRoute} from "vue-router";
const isRoot = store.getters.root;
const rList = store.getters.routers;
const router = useRouter();
const route = useRoute();

const menuClick = (item: any) => {
  if (item.index === route.path) {
    router.push({path: '/admin/redirect', query: {next: item.index}});
  }
};
</script>

<script lang="ts">
import { defineComponent } from "vue";
import { MostlyCloudy, CollectionTag, DataBoard, Document, Notebook, Reading, ShoppingBag, Setting, Tickets, User, DocumentCopy, Postcard, Key, Grape } from "@element-plus/icons-vue";

export default defineComponent({
  name: "SidebarIndex",
  components: {
    MostlyCloudy, CollectionTag, DataBoard, Document, Notebook, Reading, ShoppingBag, Setting, Tickets, User, DocumentCopy, Postcard, Key, Grape,
  },
  data() {
    return {
      activeMenuIndex: this.$route.path,
    }
  },
});
</script>

<style lang="scss">
#app .el-aside {
  --el-menu-border-color: #e6e6e6;
  border-right: solid 1px var(--el-menu-border-color);
}
#app .el-menu {
  border-right: none;
}
#app .el-menu-item a {
  display: block;
  width: 100%;
  height: 100%;
}
#app .el-aside .el-image {
   display: block;
   margin: 20px auto;
 }
#app .el-menu-item .el-icon-arrow-right {
  vertical-align: text-bottom;
}
#app .el-menu-item .el-icon {
  font-size: 18px;
  width: 24px;
  margin-right: 5px;
  vertical-align: baseline;
}
</style>
